import { takeLatest, call, select, put } from "redux-saga/effects";
import log from "loglevel"

import getEnvParam from "../../utils/getEnvParam";
import { saveAs } from "file-saver";
import { requestDefaultJson } from './helpers'

const addFilter = (filter, filterName) => {
	if (filter) {
		return '&' + filterName + '=' + filter
	} else {
		return ''
	}
}

const conciliationReportFromApi = ( token, payload) => {
	const {
		pedido, 
		conciliacao, 
		nomeFornecedor, 
		dataConciliacaoInicial,
		dataConciliacaoFinal,
		statusComercial,
		statusRFM, 
		notaFiscal, 
		perfil,
		idCd
	 } = payload.filters

	const urlFilters = 
		'perfil=' + perfil +
		addFilter(pedido, 'pedido') +
		addFilter(conciliacao, 'conciliacao') +
		addFilter(nomeFornecedor, 'nomeFornecedor') +
		addFilter(dataConciliacaoInicial, 'dataConciliacaoInicial') +
		addFilter(dataConciliacaoFinal, 'dataConciliacaoFinal') +
		addFilter(statusComercial, 'statusComercial') +
		addFilter(statusRFM, 'statusRFM') +
		addFilter(notaFiscal, 'notaFiscal') +
		addFilter(idCd, 'idCd')
	return requestDefaultJson({
		method: "GET",
		URIComplete: getEnvParam("REACT_APP_BFF_URL_REST") + '/relatorios/Reports/conciliacao.pdf?' + urlFilters,
		headers: {
			"NPF_ROUTE": getEnvParam("REACT_APP_HEADER_REPORT"),
			"Authorization": token
		},
		responseType: 'blob'
	});
};

//generators
function* getConciliationReport(payload) {
	try {
		yield put({ type: "SET_LOADING_CONCILIATION_REPORT", payload: true });

		const { token } = yield select(state => state.authentication)

		let data = yield call(conciliationReportFromApi, token, payload.payload);

		saveAs(data, `relatorio-conciliacao.pdf`);
		
		yield put({ type: "SET_LOADING_CONCILIATION_REPORT", payload: false });
	} catch (error) {
		log.info(error);
	}
}

// //Generator function
export function* conciliationReportWatcher() {
	yield takeLatest("GET_CONCILIATION_REPORT", getConciliationReport);
}
